<script>
  import { onMount } from "svelte";
  import gsap from "gsap";
  import ScrollTrigger from "gsap/ScrollTrigger";

  onMount(() => {
    gsap.registerPlugin(ScrollTrigger);
    gsap.to(".imgarea", {
      "--bg-scale": 1,
      // ease: "power4.inOut",
      // duration: 1,
      scrollTrigger: {
        trigger: ".imgarea",
        start: "top 80%",
        end: "center 45%",
        scrub: true,
        // toggleActions: "play none none reverse",
        // markers: true,
      }
    })
  })
  const appui = "/assets_default/images/business/top/appui.webp"
</script>

<section class="owd-biz-section:max:1200 owd-biz-section:spacing-bottom about-section" id="about">
  <div>
    <div class="section-head">
      <section-head biz="true" title="みんなの銀行とは" caption="ABOUT"></section-head>
    </div>
    <h2 class="owd-heading:02 spacing:bottom:24">デジタルバンクでビジネスもお得に</h2>
    <p class="owd-text:01 spacing:bottom:40">みんなの銀行は、国内最大の地域金融グループ、ふくおかフィナンシャルグループが設立した日本初のデジタルバンクです。<br>「時間・手間・コスト」という障壁を取り払い、事業に集中できるスマートな体験を提供します。</p>
    <p class="owd-text:02"><strong><a class="owd-textlink" href="https://corporate.minna-no-ginko.com/" target="_blank">会社概要</a></strong></p>
  </div>
  <div class="imgarea">
    <img class="spacing:bottom:24" src="{appui}" width="315" height="397" alt="デジタルバンクでビジネスもお得に">
  </div>
</section>

<style lang="scss">

.about-section{
  display: grid;
  grid-template-columns: calc((583px/1200px)*100%) calc((584px/1200px)*100%);
  gap: calc((32px/1200px)*100%);
  align-items: center;
  :global(.owd-biz-section-head){
    margin-bottom: 48px;
    @include g.mobile () {
      margin-bottom: 40px;
    }
  }
  .imgarea{
    position: relative;
    width: 100%;
    aspect-ratio: 1;
    --bg-scale: 0.6;
    &::before{
      content: "";
      position: absolute;
      width: 100%;
      height: 100%;
      transform: scale(var(--bg-scale));
      z-index: 0;
      background-color: var(--light-gray);
      border-radius: 50%;
    }
    img{
      width: calc((315px/584px)*100%);
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%,-50%);
      z-index: 1;
    }
  }
  @include g.mobile () {
    grid-template-columns: 1fr;
    gap: 8px;
    .owd-text\:01{
      &.spacing\:bottom\:40{
        margin-bottom: 24px;
      }
    }
  }
}
</style>
